<template>
  <div class="notification">
    <sdPopover placement="bottomLeft" action="click">
      <template v-slot:content>
        <AtbdTopDropdwon class="atbd-top-dropdwon">
          <sdHeading as="h5" class="atbd-top-dropdwon__title">
            <span class="title-text">{{ $t('header.notify.notifications') }}</span>
            <a-badge class="badge-success" :count="unreadCount" />
          </sdHeading>
          <perfect-scrollbar
            :options="{
              wheelSpeed: 1,
              swipeEasing: true,
              suppressScrollX: true,
            }"
          >
            <ul class="atbd-top-dropdwon__nav notification-list">
              <li v-for="(notify, index) in notifications" :key="index">
                <a @click="read(index)">
                  <div class="atbd-top-dropdwon__content notifications">
                    <div class="notification-icon bg-primary">
                      <sdFeatherIcons type="package" />
                    </div>
                    <div class="notification-content d-flex">
                      <div class="notification-text">
                        <sdHeading as="h5">
                          {{ $store.state.i18n.i_lang == 'en' ? notify.message_en : notify.message }}
                        </sdHeading>
                        <p>{{ dateTr(notify.created_at) }}</p>
                      </div>
                      <div class="notification-status">
                        <a-badge dot v-if="!notify.is_read" />
                      </div>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </perfect-scrollbar>
          <router-link class="btn-seeAll" :to="{ name: 'notifications' }">
            {{ $t('header.notify.view-all') }}
          </router-link>
        </AtbdTopDropdwon>
      </template>
      <a-badge :dot="unreadCount > 0" :offset="[-8, -5]">
        <a to="#" class="head-example">
          <sdFeatherIcons type="bell" size="20" />
        </a>
      </a-badge>
    </sdPopover>
  </div>
</template>
<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css';
import { AtbdTopDropdwon } from './auth-info-style';
import { dateToTr } from '@/utility/helper.js';

export default {
  name: 'Notification',
  components: {
    AtbdTopDropdwon,
    PerfectScrollbar,
  },
  data() {
    return {
      notifications: [],
      limit: 3,
      unreadCount: 0,
    };
  },
  methods: {
    getNotifications() {
      var _this = this;
      this.$appAxios.post(this.$endpoints.notifications_get, { limit: this.limit }).then((resp) => {
        if (resp.data.status === true) {
          _this.notifications = resp.data.data.data;
          _this.unreadCount = resp.data.data.unread_count;
        }
      });
    },
    read(index) {
      let notify = this.notifications[index];
      if (notify.is_read == 0) {
        let id = notify.id;
        notify.is_read = 1;
        this.$appAxios.post(this.$endpoints.notifications_read, { id: id }).then((resp) => {
          if (resp.data.status == true) {
            this.unreadCount--;
          }
        });
      }
    },
    dateTr(date) {
      return dateToTr(date);
    },
  },
  mounted() {
    this.getNotifications();
  },
};
</script>
<style scoped>
.ps {
  height: 200px;
}
</style>
